export class RecuperarClave {
  constructor(
    public usuario: string,
    public token: string,
    public claveNueva: string,
    public claveConfirmada: string,
  ){}
}
